module.exports = "<p>\n  retail works!\n</p>\n"